import { render, staticRenderFns } from "./m-editAnswerEssay.vue?vue&type=template&id=7fa4c524&"
import script from "./m-editAnswerEssay.vue?vue&type=script&lang=js&"
export * from "./m-editAnswerEssay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports